import { useEffect, useRef, useState } from "react";

/** Lange Listen häppchenweise zeigen: erst `step` Einträge, der Rest lädt beim Scrollen nach (Wächter-Element) – hält DOM und HTML klein. */
export const useLazyList = (items, step = 24, resetKey = "") => {
  const [count, setCount] = useState(step);
  const sentinel = useRef(null);
  useEffect(() => { setCount(step); }, [resetKey, step]);
  useEffect(() => {
    const el = sentinel.current;
    if (!el || count >= items.length || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) setCount((c) => Math.min(c + step, items.length)); }, { rootMargin: "600px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [count, items.length, step]);
  return { shown: items.slice(0, count), remaining: Math.max(0, items.length - count), sentinelRef: sentinel, showMore: () => setCount((c) => Math.min(c + step, items.length)) };
};

/** Wächter + Schaltfläche „Mehr anzeigen“ (für Browser ohne Beobachter und Suchmaschinen-Renderer). */
export const LazyMore = ({ lazy, label, className = "" }) => lazy.remaining > 0 ? (
  <div ref={lazy.sentinelRef} className={`flex justify-center py-6 ${className}`} data-testid="lazy-more">
    <button type="button" onClick={lazy.showMore} className="inline-flex items-center h-10 px-5 rounded-md border border-stone-200 bg-white text-sm font-medium text-stone-700 hover:border-brand hover:text-brand transition-colors" data-testid="lazy-more-btn">
      {label.replace("{n}", lazy.remaining)}
    </button>
  </div>
) : null;
